import React from "react";
import Rasika from "../../../images/RASIKABANSOD.jpg";
import Gurpreet from "../../../images/Gurpreet.jpg";
import OpportunityCardGrid from "../../ui/OpportunityCardGrid";

const FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSdhucOya_z8zfgTBbcIsxcY012Nj6Mn9y0xbuc90j89j32x_w/viewform";

const cards = [
  { name: "Social Media", description: "Content Writing, Graphic designing & Engagement", href: FORM_URL },
  { name: "Website", description: "Development, Design & Management", href: FORM_URL },
  { name: "Organisation Building", description: "Operations, Planning & Management", href: FORM_URL },
  { name: "Fundraising", description: "Grants, Crowdfunding & Corpus Funds", href: FORM_URL },
  { name: "Communications", description: "News & Media", href: FORM_URL },
  { name: "Relationship building", description: "Individuals, Corporations & High Net Worth Individual", href: FORM_URL },
];

const testimonials = [
  {
    quote: "It's a great way to give back to your local community and the world or make a difference to the people around them. One of the best things about volunteering is meeting the other volunteers and our SPOC.",
    name: "Rasika Bansod",
    role: "Volunteer, 1MillionStory Campaign",
    image: Rasika,
  },
  {
    quote: "Volunteering at KU helped me realise that perhaps kindness isn't rare; but in fact, is everywhere. The need of the hour is to be observant & kind. Today's youth must come forward to join KU in this beautiful movement- the kindness movement.",
    name: "Gurpreet Kaur N",
    role: "Volunteer, 1MillionStory Campaign",
    image: Gurpreet,
  },
];

const Volunteering = () => (
  <OpportunityCardGrid
    title="Volunteering"
    subtitle="Opportunities (Click on a domain for details)"
    cards={cards}
    testimonials={testimonials}
  />
);

export default Volunteering;
